import styled from "styled-components";

export default  styled.h2`
font-family: "Elevance Sans Semibold";
font-weight: 600;
font-size: 36px;
line-height: 48px;
text-align: center;
color: #1a3673;
`;